import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { contactStateKey } from '~/pages/ContactsDashboard/ContactsDashboard.utils';
export function useContactArchiveRestoreDelete(param) {
    let { onSuccess, bi } = param;
    const { api } = useStoreActions();
    const { showModal, showSuccessToast, showErrorToast, startLoader, stopLoader } = useOverlayContext();
    const { t: contactsDashboardTexts } = useLocaleKeys('pages.contactsDashboard');
    const { t: archiveConfirmationTexts } = useLocaleKeys('pages.contactsDashboard.archiveConfirmation');
    const { t: deleteConfirmationTexts } = useLocaleKeys('pages.contactsDashboard.deleteConfirmation');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const onRestore = async (contact)=>{
        var _bi_restore_onMenuClick, _bi_restore;
        bi === null || bi === void 0 ? void 0 : (_bi_restore = bi.restore) === null || _bi_restore === void 0 ? void 0 : (_bi_restore_onMenuClick = _bi_restore.onMenuClick) === null || _bi_restore_onMenuClick === void 0 ? void 0 : _bi_restore_onMenuClick.call(_bi_restore, contact);
        const loader = 'restore-contact-loader';
        startLoader(loader);
        const result = await handleRequest(api.contact.restore(contact.id(), {
            version: contact.version()
        }));
        if (result.success) {
            await onSuccess();
        } else {
            showErrorToast(result.error.restoreContactErrorText(errorTexts), 'restore-error-toast');
        }
        stopLoader(loader);
    };
    const onArchive = async (contact)=>{
        try {
            var _bi_archive_onMenuClick, _bi_archive;
            bi === null || bi === void 0 ? void 0 : (_bi_archive = bi.archive) === null || _bi_archive === void 0 ? void 0 : (_bi_archive_onMenuClick = _bi_archive.onMenuClick) === null || _bi_archive_onMenuClick === void 0 ? void 0 : _bi_archive_onMenuClick.call(_bi_archive, contact);
            const stateKey = contactStateKey(contact);
            const confirmed = await showModal({
                biName: 'contacts_dashboard_archive_confirmation_confirm',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(ConfirmationModal, {
                        bi: {
                            primaryButton: {
                                name: 'contacts_1_confirm'
                            },
                            secondaryButton: {
                                name: 'contacts_1_cancel'
                            }
                        },
                        skin: "danger",
                        textAlignCenter: false,
                        title: archiveConfirmationTexts.title[stateKey](),
                        content: /*#__PURE__*/ _jsx(Typography, {
                            showWhiteSpaces: true,
                            children: archiveConfirmationTexts.content[stateKey]({
                                fullName: contact.fullName()
                            })
                        }),
                        primaryButtonLabel: archiveConfirmationTexts.primaryButton(),
                        secondaryButtonLabel: archiveConfirmationTexts.secondaryButton(),
                        onPrimaryButtonClick: ()=>dismissModal(true),
                        onSecondaryButtonClick: ()=>{
                            var _bi_archive_onBack, _bi_archive;
                            bi === null || bi === void 0 ? void 0 : (_bi_archive = bi.archive) === null || _bi_archive === void 0 ? void 0 : (_bi_archive_onBack = _bi_archive.onBack) === null || _bi_archive_onBack === void 0 ? void 0 : _bi_archive_onBack.call(_bi_archive, contact);
                            dismissModal(false);
                        },
                        onCloseButtonClick: ()=>{
                            var _bi_archive_onClose, _bi_archive;
                            bi === null || bi === void 0 ? void 0 : (_bi_archive = bi.archive) === null || _bi_archive === void 0 ? void 0 : (_bi_archive_onClose = _bi_archive.onClose) === null || _bi_archive_onClose === void 0 ? void 0 : _bi_archive_onClose.call(_bi_archive, contact);
                            dismissModal(false);
                        }
                    });
                }
            });
            if (confirmed) {
                var _bi_archive_onConfirm, _bi_archive1, _bi_archive_onSuccess, _bi_archive2;
                bi === null || bi === void 0 ? void 0 : (_bi_archive1 = bi.archive) === null || _bi_archive1 === void 0 ? void 0 : (_bi_archive_onConfirm = _bi_archive1.onConfirm) === null || _bi_archive_onConfirm === void 0 ? void 0 : _bi_archive_onConfirm.call(_bi_archive1, contact);
                startLoader('archive-contact-loader');
                await api.contact.archive(contact.id(), {
                    version: contact.version()
                });
                bi === null || bi === void 0 ? void 0 : (_bi_archive2 = bi.archive) === null || _bi_archive2 === void 0 ? void 0 : (_bi_archive_onSuccess = _bi_archive2.onSuccess) === null || _bi_archive_onSuccess === void 0 ? void 0 : _bi_archive_onSuccess.call(_bi_archive2, contact);
                showSuccessToast(contactsDashboardTexts.archiveSuccessToast(), 'archive-success-toast');
                await onSuccess();
            }
        } catch (err) {
            showErrorToast(new ErrorResponse(err).archiveContactErrorText(errorTexts), 'archive-error-toast');
        } finally{
            stopLoader('archive-contact-loader');
        }
    };
    const onDelete = async (contact)=>{
        try {
            var _bi_delete_onMenuClick, _bi_delete;
            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onMenuClick = _bi_delete.onMenuClick) === null || _bi_delete_onMenuClick === void 0 ? void 0 : _bi_delete_onMenuClick.call(_bi_delete, contact);
            const stateKey = contactStateKey(contact);
            const confirmed = await showModal({
                biName: 'contacts_dashboard_delete_confirmation_ke_confirm',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(ConfirmationModal, {
                        bi: {
                            primaryButton: {
                                name: 'contacts_3_confirm'
                            },
                            secondaryButton: {
                                name: 'contacts_3_cancel'
                            }
                        },
                        skin: "danger",
                        textAlignCenter: false,
                        title: deleteConfirmationTexts.title[stateKey](),
                        content: /*#__PURE__*/ _jsx(Typography, {
                            showWhiteSpaces: true,
                            children: deleteConfirmationTexts.content[stateKey]({
                                fullName: contact.fullName()
                            })
                        }),
                        primaryButtonLabel: deleteConfirmationTexts.primaryButton(),
                        secondaryButtonLabel: deleteConfirmationTexts.secondaryButton(),
                        onPrimaryButtonClick: ()=>dismissModal(true),
                        onSecondaryButtonClick: ()=>{
                            var _bi_delete_onBack, _bi_delete;
                            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onBack = _bi_delete.onBack) === null || _bi_delete_onBack === void 0 ? void 0 : _bi_delete_onBack.call(_bi_delete, contact);
                            dismissModal(false);
                        },
                        onCloseButtonClick: ()=>{
                            var _bi_delete_onClose, _bi_delete;
                            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onClose = _bi_delete.onClose) === null || _bi_delete_onClose === void 0 ? void 0 : _bi_delete_onClose.call(_bi_delete, contact);
                            dismissModal(false);
                        }
                    });
                }
            });
            if (confirmed) {
                var _bi_delete_onConfirm, _bi_delete1, _bi_delete_onSuccess, _bi_delete2;
                bi === null || bi === void 0 ? void 0 : (_bi_delete1 = bi.delete) === null || _bi_delete1 === void 0 ? void 0 : (_bi_delete_onConfirm = _bi_delete1.onConfirm) === null || _bi_delete_onConfirm === void 0 ? void 0 : _bi_delete_onConfirm.call(_bi_delete1, contact);
                startLoader('delete-contact-loader');
                await api.contact.delete(contact.id());
                bi === null || bi === void 0 ? void 0 : (_bi_delete2 = bi.delete) === null || _bi_delete2 === void 0 ? void 0 : (_bi_delete_onSuccess = _bi_delete2.onSuccess) === null || _bi_delete_onSuccess === void 0 ? void 0 : _bi_delete_onSuccess.call(_bi_delete2, contact);
                showSuccessToast(contactsDashboardTexts.deleteSuccessToast(), 'delete-success-toast');
                await onSuccess();
            }
        } catch (err) {
            showErrorToast(new ErrorResponse(err).deleteContactErrorText(errorTexts), 'delete-error-toast');
        } finally{
            stopLoader('delete-contact-loader');
        }
    };
    return {
        onArchive,
        onRestore,
        onDelete
    };
}
